import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { SnotifyService } from "ng-snotify";
import { CompanyService } from "../../../../services/company.service";
import { EngineerService } from "../../../../services/engineer.service";
import { LocationService } from "../../../../services/location.service";



@Component({
  selector: 'app-engineers-manage',
  templateUrl: './engineers-manage.component.html',
  styleUrls: ['./engineers-manage.component.scss']
})
export class EngineersManageComponent implements OnInit {

  id: number= 0;
 
  firstname: string = "";
  surname: string = "";
  credentials: string = "";

  password: string = "";
  password2: string = "";
  userId: number = 0;
  selectedLocations: Location[];
  locationList: Location[];
  userids;
  isEdit: boolean = false;
  constructor(private engineerService: EngineerService, private locationService: LocationService,
    private companyService: CompanyService,
    private router: Router, private route: ActivatedRoute, private snotifyService: SnotifyService) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe((paramsMap) => {
      var id = paramsMap.get("id");
      //console.log(id);
      if (id != null) {

        this.engineerService.get(id).then((user) => {
          //console.log(user);
          this.id = user.id;
          this.firstname = user.firstname;
          this.surname = user.surname;
          this.credentials = user.credentials;

          this.password = user.pin;
          this.password2 = user.pin
          this.isEdit = true;
        });
      } else {
        this.isEdit = false;
      }
      //console.log(this.isEdit);
    });
  }

  back() {
    this.router.navigate(['engineers']);
  }

  validate() {
    if (this.firstname == null || this.firstname == "") {
      this.snotifyService.error("Enter firstname");
      //alert("Enter firstname");
      return false;
    }
    if (this.surname == null || this.surname == "") {
      this.snotifyService.error("Enter surname");
      //alert("Enter firstname");
      return false;
    }
    
    if (this.credentials == null || this.credentials == "") {
      this.snotifyService.error("Enter credentials");
      //alert("Enter firstname");
      return false;
    }


    if ((this.password == null || this.password == "") && (this.password2 != null && this.password2 != "")) {
      this.snotifyService.error("Enter password");
      //alert("Enter password");
      return false;
    }

    if ((this.password != null && this.password != "") && (this.password2 == null || this.password2 == "")) {
      this.snotifyService.error("Enter password");
      //alert("Enter password");
      return false;
    }

    if ((this.password != null && this.password != "") && (this.password2 != null && this.password2 != "") && (this.password != this.password2)) {
      this.snotifyService.error("Passwords do not match");
      //alert("Passwords do not match");
      return false;
    }


    return true;
  }

  async save() {
    if (!this.validate()) {
      return;
    }

    if (this.id == null)
      this.id = 0;

    var user = {
      id: this.id,
      firstname: this.firstname,
      surname: this.surname,
      credentials: this.credentials,
      pin: this.password,
     
    };


    if (this.id == null)
      await this.engineerService.add(user);
    else
      await this.engineerService.update(user);

    this.router.navigate(['engineers']);
  }

  async delete() {
    await this.engineerService.delete(this.id);
    this.router.navigate(['engineers']);
  }

}
